import { useAppQuery } from "../../querys/useAppQuery";
import { AxiosError } from "axios";
import { IErrorResponse, QueryKeys } from "../../querys/querys.enum";
import axiosInstance from "../../../utils/axios";
import { SGTemplatesResponse } from "../../../models/Interface/SGTemplate.interface";

const useSGTemplates = () => {
  return useAppQuery<SGTemplatesResponse, AxiosError<IErrorResponse>>({
    queryKey: [QueryKeys.SG_TEMPLATES],
    queryFn: async () => {
      return (await axiosInstance.get(`/sg-template-management`)).data;
    },
    enabled: true,
    retry: 0,
  });
};

export default useSGTemplates;
